import {
  createGenericSaga,
  defaultSagaErrorHandler,
  defaultSagaSuccessHandler
} from "framework/sagas/sagaUtilities";
import { getApiRegistry } from "framework/state/apiRegistry";

export const trainingManagementSagas = {
  getNodes: createGenericSaga(
    "trainingManagementSagas/getNodes",
    getApiRegistry().trainingApi.apiTrainingNodesGet.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      //onSuccess: defaultSagaSuccessHandler("Fetched all nodes"),
      onFail: defaultSagaErrorHandler
    }
  ),
  getNode: createGenericSaga(
    "trainingManagementSagas/getNode",
    getApiRegistry().trainingApi.apiTrainingNodeGet.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      //onSuccess: defaultSagaSuccessHandler("Fetched node"),
      onFail: defaultSagaErrorHandler
    }
  ),
  getNodesRoots: createGenericSaga(
    "trainingManagementSagas/getNodesRoots",
    getApiRegistry().trainingApi.apiTrainingNodesRootsGet.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      //onSuccess: defaultSagaSuccessHandler("Fetched all roots"),
      onFail: defaultSagaErrorHandler
    }
  ),
  getArticles: createGenericSaga(
    "trainingManagementSagas/getArticles",
    getApiRegistry().trainingApi.apiTrainingArticlesGet.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      //onSuccess: defaultSagaSuccessHandler("Filtered articles for node"),
      onFail: defaultSagaErrorHandler
    }
  ),
  getArticleById: createGenericSaga(
    "trainingManagementSagas/getArticleById",
    getApiRegistry().trainingApi.apiTrainingArticleIdGet.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      onFail: defaultSagaErrorHandler
    }
  ),
  updateNode: createGenericSaga(
    "trainingManagementSagas/updateNode",
    getApiRegistry().trainingApi.apiTrainingNodePut.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      onSuccess: defaultSagaSuccessHandler("Updated"),
      onFail: defaultSagaErrorHandler
    }
  ),
  updateArticle: createGenericSaga(
    "trainingManagementSagas/updateArticle",
    getApiRegistry().trainingApi.apiTrainingArticlePut.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      onSuccess: defaultSagaSuccessHandler("Updated"),
      onFail: defaultSagaErrorHandler
    }
  ),
  deleteNode: createGenericSaga(
    "trainingManagementSagas/deleteNode",
    getApiRegistry().trainingApi.apiTrainingNodeDelete.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      onSuccess: defaultSagaSuccessHandler("Node deleted"),
      onFail: defaultSagaErrorHandler
    }
  ),
  sendFeedback: createGenericSaga(
    "supportLineSagas/sendFeedback",
    getApiRegistry().trainingApi.apiTrainingFeedbackPost.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      onSuccess: defaultSagaSuccessHandler("Feedback sent"),
      onFail: defaultSagaErrorHandler
    }
  ),
  getKey: createGenericSaga(
    "training/getKey",
    getApiRegistry().trainingApi.apiTrainingGetSearchKeyGet.bind(getApiRegistry().trainingApi),
    {
      takeEvery: false,
      onFail: defaultSagaErrorHandler
    }
  )
};
